export default __webpack_public_path__ + "static/media/service_banner.a622dfa6.png";